import React from "react";
import { Link, NavLink } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import logo from "../../assets/logo.png";
import { navLinks } from "../../data/navLinks";
import Button from "../ui/Button";

/**
 * Slide-in mobile navigation drawer.
 */
const MobileMenu = ({ open, onClose }) => {
  // Flatten the Services dropdown into inline links for mobile.
  const flatLinks = navLinks.flatMap((link) =>
    link.children ? [link, ...link.children.map((c) => ({ ...c, nested: true }))] : [link]
  );

  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 z-40 h-dvh bg-black/40 transition-opacity lg:hidden ${
          open ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Drawer — full viewport height, flex column */}
      <aside
        className={`fixed left-0 top-0 z-50 flex h-dvh w-4/5 min-w-[280px] max-w-sm flex-col bg-surface p-6 shadow-xl transition-transform duration-300 lg:hidden ${
          open ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between">
          <Link to="/" onClick={onClose}>
            <img src={logo} alt="Cargo Power Logistics" className="h-16 w-auto" />
          </Link>
          <button
            type="button"
            onClick={onClose}
            className="flex h-10 w-10 items-center justify-center rounded-lg text-primary"
            aria-label="Close menu"
          >
            <IoClose className="text-3xl" />
          </button>
        </div>

        {/* Links fill the available height */}
        <ul className="mt-8 flex flex-grow flex-col justify-center gap-1 overflow-y-auto">
          {flatLinks.map((link) => (
            <li key={`${link.label}-${link.to}`}>
              <NavLink
                to={link.to}
                end={link.to === "/"}
                onClick={onClose}
                className={({ isActive }) =>
                  `block border-b border-outline-variant/40 py-3 font-body-md transition-colors ${
                    link.nested ? "pl-4 text-body-md" : "text-body-lg"
                  } ${isActive ? "text-primary" : "text-on-surface-variant hover:text-primary"}`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <Button to="/contact" onClick={onClose} className="mt-6 w-full shrink-0">
          Request Quote
        </Button>
      </aside>
    </>
  );
};

export default MobileMenu;
